module.exports = __webpack_public_path__ + "static/img/exclusive-gateway.56b82dfd.svg";